module.exports = __webpack_public_path__ + "img/new-wenwen.5f1c8307.png";